import React from 'react';

import { AccessibilityProps, Pressable, StyleSheet, View, ViewProps } from 'react-native';

import { primitive } from 'styles/constants';

import { styles as sharedStyles } from '../styles';

export const BADGE_CARD_WIDTH = 144;
export const BADGE_CARD_MIN_HEIGHT = 187;

export const BadgeBaseCard = ({
  image,
  title,
  subtitle,
  progress,
  onPress,
  accessibilityRole,
  accessibilityLabel,
  style,
}: {
  image: React.ReactNode;
  title: React.ReactNode;
  style?: ViewProps['style'];
  subtitle?: React.ReactNode;
  progress?: React.ReactNode;
  onPress?: () => void;
  accessibilityRole?: AccessibilityProps['accessibilityRole'];
  accessibilityLabel?: AccessibilityProps['accessibilityLabel'];
}) => {
  return (
    <View style={[styles.wrapper, style, sharedStyles.cardElevationStyles]}>
      <Pressable
        style={styles.pressable}
        onPress={onPress}
        accessibilityRole={accessibilityRole}
        accessibilityLabel={accessibilityLabel}
      >
        {image}
        <View style={styles.content}>
          {title}
          {progress ?? subtitle}
        </View>
      </Pressable>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: primitive.$white,
    borderRadius: 12,
    margin: 2,
  },
  pressable: {
    overflow: 'hidden',
    width: BADGE_CARD_WIDTH,
    minHeight: BADGE_CARD_MIN_HEIGHT,
    paddingVertical: 16,
    paddingHorizontal: 12,
    alignItems: 'center',
    gap: 12,
  },
  content: {
    alignItems: 'center',
    gap: 4,
    width: '100%',
  },
});
